import { http } from "services/http";

import type {
  NotificationSetting,
  NotificationUpdateRequest,
  NotificationUpdateResponse,
} from "models/notifications.model";

export const notificationsApi = {
  getNotifications: () => http.quiet().post<NotificationSetting[]>("/api/notifications", {}),
  updateNotification: (data: NotificationUpdateRequest) =>
    http.quiet().post<NotificationUpdateResponse>("/api/notifications/update", { ...data }),
};
